import { Loader } from '@lyra/core/components/Icon'
import Tag from '@lyra/core/components/Tag'
import Tooltip from '@lyra/core/components/Tooltip'
import formatRelativeDateTime from '@lyra/core/utils/formatRelativeDateTime'
import { YieldTokenId } from '@lyra/web/constants/yield'
import { getYieldTokenConfig } from '@lyra/web/utils/yield'

type Props = {
  yieldId: YieldTokenId
  isLarge?: boolean
}

export const YieldIsExecutingTag = ({ yieldId, isLarge }: Props) => {
  const config = getYieldTokenConfig(yieldId)

  const earlyDepositLabel = config.isEarlyDeposit
    ? config.startExecutingTimestampUTC
      ? `Live ${formatRelativeDateTime(config.startExecutingTimestampUTC)}`
      : 'Pre-Deposit'
    : 'Live'

  const tooltipContent = config.isEarlyDeposit
    ? config.startExecutingTimestampUTC
      ? `This vault has reached the threshold TVL and will begin executing strategy ${formatRelativeDateTime(
          config.startExecutingTimestampUTC
        )}.`
      : `This vault is in pre-deposit phase and will begin executing strategy on the first Friday after crossing $250,000 TVL. Users continue to earn underlying asset yield and all partner points in the pre-deposit phase.`
    : 'This vault is executing its options strategy every week and generating yield.'

  return (
    <Tooltip
      title={!config.isEarlyDeposit ? 'Live' : 'Pre-deposit'}
      content={tooltipContent}
      trigger={
        <Tag
          cursor="help"
          isLarge={isLarge}
          icon={config.isEarlyDeposit ? <Loader /> : null}
          label={earlyDepositLabel}
        />
      }
    />
  )
}
